import { kebabCase } from "lodash"

// All lightboxes with trigger a custom event with product name and type of content.
const lightboxes = Array.from(document.querySelectorAll(".js-lightbox-open"))
lightboxes.forEach((lightbox) => {
	lightbox.addEventListener("click", () => {
		window.dataLayer.push({
			event: "lightbox-open",
			productName: lightbox.dataset.name,
			contentName: lightbox.dataset.content,
			productCode: lightbox.dataset.code,
		})
	})
})

// All forms with trigger a custom event with their name.
const forms = Array.from(document.querySelectorAll("form"))
forms.forEach((form) => {
	form.addEventListener("submit", () => {
		const formHandle = form.querySelector("input[name=\"handle\"]").value
		const event = form.dataset.event ? form.dataset.event : "form-submit"

		window.dataLayer.push({
			event,
			formName: kebabCase(formHandle),
		})
	})
})